import Icon from '../components/Icon.vue'

Icon.register({"object-group":{"width":512,"height":512,"paths":[{"d":"M480 128V96H500C506.6 96 512 90.6 512 84V44C512 37.4 506.6 32 500 32H460C453.4 32 448 37.4 448 44V64H64V44C64 37.4 58.6 32 52 32H12C5.4 32 0 37.4 0 44V84C0 90.6 5.4 96 12 96H32V416H12C5.4 416 0 421.4 0 428V468C0 474.6 5.4 480 12 480H52C58.6 480 64 474.6 64 468V448H448V468C448 474.6 453.4 480 460 480H500C506.6 480 512 474.6 512 468V428C512 421.4 506.6 416 500 416H480V128zM96 276V140C96 133.4 101.4 128 108 128H276C282.6 128 288 133.4 288 140V276C288 282.6 282.6 288 276 288H108C101.4 288 96 282.6 96 276zM416 372C416 378.6 410.6 384 404 384H236C229.4 384 224 378.6 224 372V320H296C309.3 320 320 309.3 320 296V224H404C410.6 224 416 229.4 416 236V372z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/object-group.js
// module id = 1f41
// module chunks = 0